import _extends from "@babel/runtime/helpers/esm/extends";
// Modules
import Bowser from 'bowser';

// Types

export let PlatformFamily = /*#__PURE__*/function (PlatformFamily) {
  PlatformFamily["DESKTOP"] = "desktop";
  PlatformFamily["MOBILE"] = "mobile";
  PlatformFamily["TABLET"] = "tablet";
  PlatformFamily["TV"] = "tv";
  return PlatformFamily;
}({});
export default class Platform {
  constructor({
    family,
    id,
    name,
    sdk,
    stack = 'web',
    userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '',
    version,
    device
  }) {
    this.app = void 0;
    this.device = void 0;
    this.browser = void 0;
    this.os = void 0;
    const familyProvided = typeof family !== 'undefined';
    this.app = {
      family: family || PlatformFamily.DESKTOP,
      id,
      name: name.toLowerCase(),
      sdk,
      stack,
      version: version.toLowerCase()
    };
    if (device) this.device = {
      name: device.name.toLowerCase()
    };
    if (userAgent) {
      var _browser$getBrowserVe, _browser$getOSVersion;
      const browser = Bowser.getParser(userAgent);
      if (!familyProvided) {
        const isCast = userAgent.includes('CrKey');

        // prettier-ignore
        this.app.family = isCast ? PlatformFamily.TV : browser.is('tablet') ? PlatformFamily.TABLET : browser.is('mobile') ? PlatformFamily.MOBILE : this.app.family;
      }
      this.browser = {
        name: browser.getBrowserName(),
        version: (_browser$getBrowserVe = browser.getBrowserVersion()) != null ? _browser$getBrowserVe : 'N/A' // getBrowserVersion is mostly undefined on Webviews
      };
      this.os = {
        name: browser.getOSName(),
        version: (_browser$getOSVersion = browser.getOSVersion()) != null ? _browser$getOSVersion : 'N/A' // getOSVersion is mostly undefined on Linux
      };
    }
  }
  static deserialize({
    app,
    browser,
    os
  }) {
    return Object.assign(new Platform(app), {
      browser,
      os
    });
  }
  serialize() {
    return _extends({}, this);
  }
}
//# sourceMappingURL=Platform.js.map